import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { articles } from '../../data/articles';
import './Articles.css';

const Articles: React.FC = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="articles-page">
      <div className="articles-container">
        
        <div className="articles-header">
          <h1 className="articles-title">Industrybull <span>Articles</span></h1>
          <p className="articles-subtitle">
            Stay updated with the latest trends, guides, and news.
          </p>
        </div>

        <div className="articles-grid">
          {articles.map((article) => (
            <div key={article.id} className="article-card">
              <Link to={`/articles/${article.id}`} className="article-card__image-container">
                <span className="article-card__placeholder"><svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="#9CA3AF" strokeWidth="1.5"><path d="M4 22h16a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2H8a2 2 0 0 0-2 2v16a2 2 0 0 0-2 2zm0 0a2 2 0 0 1-2-2v-9c0-1.1.9-2 2-2h2"/></svg></span>
                <span className="article-card__category-badge">{article.category}</span>
              </Link>
              
              <div className="article-card__content">
                <h3 className="article-card__title">
                  <Link to={`/articles/${article.id}`}>{article.title}</Link>
                </h3>
                
                <div className="article-card__meta">
                  <span>{article.date}</span>
                </div>
                
                <div className="article-card__footer">
                  <Link to={`/articles/${article.id}`} className="article-card__read-more">
                    Read Article
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                      <path fillRule="evenodd" d="M12.293 5.293a1 1 0 011.414 0l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-2.293-2.293a1 1 0 010-1.414z" clipRule="evenodd" />
                    </svg>
                  </Link>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="articles-load-more">
          <button className="articles-load-more-btn">Load More Articles</button>
        </div>

      </div>
    </div>
  );
};

export default Articles;
